




















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { PermissionControlForm } from '@/models/dailyControl'
import { EmployeeModel, ReasonForPermissionModel } from '@/models/config'

// Components
import { FormCreateEditPermissionControl } from '@/components/dailyControl'

@Component({
    name: 'ModalCreateEditPermissionControl',
    components: {
        FormCreateEditPermissionControl
    }
})
export default class ModalCreateEditPermissionControl extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) permissionControl!: PermissionControlForm
    @Prop({ type: Array, default: () => [] }) employees!: EmployeeModel[]
    @Prop({ type: Array, default: () => [] }) reasons!: ReasonForPermissionModel[]

    get title () {
        if (this.actionForm === 'save') {
            return 'Agregar Control de Permiso de Empleados'
        }
        return 'Agregar Control de Permiso de Empleados'
    }
}
